import Masonry from 'masonry-layout';

export default function focusInit(){
    var focus = document.querySelector('.focus-grid');
    if (focus) {
        focus.classList.add('masonry');
        var msnry = new Masonry( focus, {
            // options
            gutter: '.msnry-gutter',
            itemSelector: '.focus',
        });
    }    
}